import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupService } from '../../shared/modal/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../shared/alert/alert.service';
import { LotImportUpdateBalanceMappingDialogComponent } from './lot-import-update-balance-mapping.dialog.component';
import { FileDownloadHelper } from '../sample/file-download.helper';
import { JhiAlertService, JhiEventManager } from '../../shared/core-utils';
import { parseFile } from '../../shared/util/file-utils';
import { InventoryService } from '../../shared/inventory/service/inventory.service';
import { LotService } from '../../shared/inventory/service/lot.service';
import { LotTemplateExportType } from '../../shared/inventory/service/lot-template-export-type';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-import-update-balance-dialog',
    templateUrl: './lot-import-update-balance-dialog.component.html'
})
export class LotImportUpdateBalanceDialogComponent implements OnInit, OnDestroy {

    @ViewChild('fileUpload')
        fileUpload: ElementRef;

    fileName = '';
    importData = new Array<any>();
    importHeader = [];
    subscriptionsManager = new SubscriptionsManager();

    importFormats = [
        { name: 'CSV', extension: '.csv' }, //
        { name: 'Excel', extension: '.xls,.xlsx' }
    ];

    selectedFileType = this.importFormats[1].extension; // '.xlsx'; // Set the default file type to CSV.

    constructor(
        private alertService: AlertService,
        public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private lotService: LotService,
        private fileDownloadHelper: FileDownloadHelper,
        private eventManager: JhiEventManager,
        private translateService: TranslateService) {

    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    ngOnInit(): void {
    }

    close() {
        this.activeModal.dismiss('cancel');
    }

    import() {
        if (this.validateFileEmpty()) {
            const confirmModalRef = this.modalService.open(LotImportUpdateBalanceMappingDialogComponent as Component, {
                size: 'lg',
                backdrop: 'static'
            });
            confirmModalRef.componentInstance.importData = this.importData;
            confirmModalRef.result.then(() => {
                this.close();
            });
        }
    }

    clearSelectedFile(): void {
        this.importData = null;
    }

    onFileChange(evt: any) {
        const target = evt.target;
        this.fileName = target.files[0].name;

        const extension = this.fileName.split('.');
        if (extension[1].toLowerCase() !== 'xls' && extension[1].toLowerCase() !== 'xlsx' && extension[1].toLowerCase() !== 'csv') {
            this.fileName = '';
            target.value = '';
            this.alertService.error('inventoryManagerApp.error.import.lots.invalid.file.ext.csv');
            return;
        }

        this.subscriptionsManager.add = parseFile(target.files[0], '').subscribe((value) => {
            this.importData = value;
        });
    }

    private validateFileEmpty() {
        if (!this.importData || this.importData.filter((row) => row.some((column) => Boolean(column.trim()))).length <= 1) {
            this.alertService.error('error.import.file.empty');
            return false;
        }
        return true;
    }

    private onSaveSuccess(result: any) {
        this.activeModal.close(result);
    }

    export($event) {
        $event.preventDefault();
        this.subscriptionsManager.add = this.lotService.downloadLotsTemplate(LotTemplateExportType.LOT_UPDATE_BALANCE).subscribe((response) => {
            const fileName = this.fileDownloadHelper.getFileNameFromResponseContentDisposition(response);
            this.fileDownloadHelper.save(response.body, fileName);

        });
    }

}

@Component({
    selector: 'jhi-lot-import-update-balance-popup',
    template: ''
})
export class LotImportUpdateBalancePopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(private inventoryService: InventoryService,
                private jhiAlertService: JhiAlertService,
                private route: ActivatedRoute,
                private popupService: PopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.popupService
                .open(LotImportUpdateBalanceDialogComponent as Component);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }

}
